import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  audio_bar: {
    "margin-top": "1rem",
    "padding": "0rem",
    "background-color": "rgb(20,20,20)",
    "position": "fixed",
    "bottom": "0px",
    "left": "0",
    "width": "100%"
  }
}));

